import { UMIcon, UMR } from '../_components';
import { pipeDensityState, pipeLength, type DensityResult } from './density';
import { DENSITY_UNIT, formatDensity, LOOPS, NO_VALUE } from './densityLegend';
import type { Pipe } from './network';
import { DensityStaleWarning } from './NetworkLegend';

export const PIPE_POPUP_TITLE = 'Canalisation de la sélection';

/** Short readable identifier: internal ids are UUIDs (manual) or technical keys (simulated). */
export function pipeDisplayId(id: string) {
  let hash = 0;
  for (const char of id) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return `CAN-${hash.toString(36).toUpperCase().padStart(6, '0').slice(-6)}`;
}

function densityLabel(pipe: Pipe, result?: DensityResult) {
  if (!result) return 'Non calculée';
  const state = pipeDensityState(result.byPipe[pipe.id]);
  if (state.kind === 'value') return `${formatDensity(state.density)} ${DENSITY_UNIT}`;
  return state.kind === 'loop' ? LOOPS.label : NO_VALUE.label;
}

/** Map pop-in content (E3), same layout as the production "Canalisation existante" popup. */
export function PipePopupContent({ pipe, result, stale, onClose }: {
  pipe: Pipe; result?: DensityResult; stale: boolean; onClose: () => void;
}) {
  return <div role="dialog" aria-label={PIPE_POPUP_TITLE}
    style={{ fontFamily: UMR.font, fontSize: 14, lineHeight: '25px', color: UMR.black }}>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
      <span style={{ fontWeight: 700 }}>{PIPE_POPUP_TITLE}</span>
      <button type="button" aria-label="Fermer" onClick={onClose}
        style={{ border: 'none', background: 'transparent', padding: 0, cursor: 'pointer', display: 'flex' }}>
        <UMIcon name="close" size={22} weight={700} color={UMR.black} />
      </button>
    </div>
    <ul style={{ margin: '14px 0 0', paddingLeft: 50, listStyle: 'disc' }}>
      <li><strong>ID:</strong> {pipeDisplayId(pipe.id)}</li>
      <li><strong>Longueur:</strong> {Math.round(pipeLength(pipe)).toLocaleString('fr-FR')} ml</li>
      <li aria-label="Densité de la canalisation">
        <strong>Densité linéaire:</strong> {densityLabel(pipe, result)}
      </li>
    </ul>
    {result && stale && <div style={{ marginTop: 4 }}><DensityStaleWarning /></div>}
  </div>;
}
